const INPUT_EVENTS = {
    MOUSE_DOWN: 0x0,            // 0 *
    MOUSE_DOWN_ACTIVATE: 0x1,   // 1
    MOUSE_DOUBLE_CLICK: 0x2,    // 2
    MOUSE_DRAG: 0x4,            // 4
    MOUSE_MOVE: 0x8,            // 8
    MOUSE_UP: 0x16              // 16
};


export { INPUT_EVENTS as default }